/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
	name: "TreeNode",
	props: ["node", "selected_node"],
	components: {
		TreeNode: () => frappe.ui.components.TreeNode
	},
	computed: {
		icon() {
			let icons = {
				open: frappe.utils.icon("folder-open", "md"),
				closed: frappe.utils.icon("folder-normal", "md"),
				leaf: frappe.utils.icon("primitive-dot", "xs"),
				search: frappe.utils.icon("search")
			};

			if (this.node.by_search) return icons.search;
			if (this.node.is_leaf) return icons.leaf;
			if (this.node.open) return icons.open;
			return icons.closed;
		}
	}
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-node", class: { opened: _vm.node.open } },
    [
      _c(
        "span",
        {
          staticClass: "tree-link",
          class: { active: _vm.node.value === _vm.selected_node.value },
          attrs: { disabled: _vm.node.fetching },
          on: {
            click: function($event) {
              return _vm.$emit("node-click", _vm.node)
            }
          }
        },
        [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.icon) } }),
          _vm._v(" "),
          _c("a", { staticClass: "tree-label" }, [
            _vm._v(_vm._s(_vm.node.label))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.node.open,
              expression: "node.open"
            }
          ],
          staticClass: "tree-children"
        },
        [
          _vm._l(_vm.node.children, function(n) {
            return _c("TreeNode", {
              key: n.value,
              attrs: { node: n, selected_node: _vm.selected_node },
              on: {
                "node-click": function(n) {
                  return _vm.$emit("node-click", n)
                },
                "load-more": function(n) {
                  return _vm.$emit("load-more", n)
                }
              }
            })
          }),
          _vm._v(" "),
          _vm.node.has_more_children
            ? _c(
                "button",
                {
                  staticClass: "btn btn-xs btn-load-more",
                  attrs: { disabled: _vm.node.children_loading },
                  on: {
                    click: function($event) {
                      return _vm.$emit("load-more", _vm.node)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.node.children_loading
                          ? _vm.__("Loading...")
                          : _vm.__("Load more")
                      ) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-23974a16_0", { source: "\n.btn-load-more[data-v-23974a16] {\n\tmargin-left: 1.6rem;\n\tmargin-top: 0.5rem;\n}\n", map: {"version":3,"sources":["frappe/public/js/frappe/file_uploader/TreeNode.vue"],"names":[],"mappings":";AAwDA;CACA,mBAAA;CACA,kBAAA;AACA","file":"TreeNode.vue","sourcesContent":["<template>\n\t<div class=\"tree-node\" :class=\"{ opened: node.open }\">\n\t\t<span\n\t\t\tclass=\"tree-link\"\n\t\t\t@click=\"$emit('node-click', node)\"\n\t\t\t:class=\"{ active: node.value === selected_node.value }\"\n\t\t\t:disabled=\"node.fetching\"\n\t\t>\n\t\t\t<div v-html=\"icon\"></div>\n\t\t\t<a class=\"tree-label\">{{ node.label }}</a>\n\t\t</span>\n\t\t<ul class=\"tree-children\" v-show=\"node.open\">\n\t\t\t<TreeNode\n\t\t\t\tv-for=\"n in node.children\"\n\t\t\t\t:key=\"n.value\"\n\t\t\t\t:node=\"n\"\n\t\t\t\t:selected_node=\"selected_node\"\n\t\t\t\t@node-click=\"n => $emit('node-click', n)\"\n\t\t\t\t@load-more=\"n => $emit('load-more', n)\"\n\t\t\t/>\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-xs btn-load-more\"\n\t\t\t\tv-if=\"node.has_more_children\"\n\t\t\t\t@click=\"$emit('load-more', node)\"\n\t\t\t\t:disabled=\"node.children_loading\"\n\t\t\t>\n\t\t\t\t{{ node.children_loading ? __(\"Loading...\") : __(\"Load more\") }}\n\t\t\t</button>\n\t\t</ul>\n\t</div>\n</template>\n<script>\nexport default {\n\tname: \"TreeNode\",\n\tprops: [\"node\", \"selected_node\"],\n\tcomponents: {\n\t\tTreeNode: () => frappe.ui.components.TreeNode\n\t},\n\tcomputed: {\n\t\ticon() {\n\t\t\tlet icons = {\n\t\t\t\topen: frappe.utils.icon(\"folder-open\", \"md\"),\n\t\t\t\tclosed: frappe.utils.icon(\"folder-normal\", \"md\"),\n\t\t\t\tleaf: frappe.utils.icon(\"primitive-dot\", \"xs\"),\n\t\t\t\tsearch: frappe.utils.icon(\"search\")\n\t\t\t};\n\n\t\t\tif (this.node.by_search) return icons.search;\n\t\t\tif (this.node.is_leaf) return icons.leaf;\n\t\t\tif (this.node.open) return icons.open;\n\t\t\treturn icons.closed;\n\t\t}\n\t}\n};\n</script>\n<style scoped>\n.btn-load-more {\n\tmargin-left: 1.6rem;\n\tmargin-top: 0.5rem;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-23974a16"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frappe/public/js/frappe/file_uploader/TreeNode.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__